// actions
import { SYSTEM_SLICE_NAME } from '../actions/system.action';

// thunks
import {
  deleteSystem,
  createSystem,
  updateSystem,
  getDesignations,
  fetchMainSystems,
  getDisciplines,
  fetchSystems
} from '../thunks/system.thunk';
import { getDisciplineListV2, getSystemSubListV2 } from '../thunks/system.thunkV2';

// models
import type { SystemState } from '../models/system.model';

// libraries
import { createSlice } from '@reduxjs/toolkit';
import { IDialogType } from 'modules/notice/models/notice.model';

// initialState
const initialState: SystemState = {
  system: [],
  category: [],
  designation: [],
  subCatetory: [],
  disciplineOption: [],
  code: undefined,
  totalMap: undefined,

  // === spring98 === //
  mainSystems: [],
  mainSystemDetail: {
    systemId: '',
    clsCd: 0,
    clsNm: '',
    cdNo: 0,
    cdNm: '',
    optCd1: 0,
    optCd2: ''
  },
  systems: [],
  systemOptions: [],
  systemDetail: {
    systemId: '',
    clsCd: 0,
    clsNm: '',
    cdNo: 0,
    cdNm: '',
    optCd1: 0,
    optCd2: ''
  },
  designations: [],
  designationOptions: [],
  disciplines: [],
  disciplineOptions: [],
  dialog: {
    type: IDialogType.none,
    message: undefined,
    isNavigate: false,
    callback: () => {}
  }
};

// createSlice
const systemSlice = createSlice({
  name: SYSTEM_SLICE_NAME,
  initialState,
  reducers: {
    changeMainSystemDetail: (state, action) => {
      state.mainSystemDetail = {
        ...state.mainSystemDetail,
        ...action.payload
      };
    },
    changeSystemDetail: (state, action) => {
      state.systemDetail = {
        ...state.systemDetail,
        ...action.payload
      };
    },
    resetSystemDetail: (state) => {
      state.systemDetail = initialState.systemDetail;
    },
    changeDialog: (state, action) => {
      state.dialog = {
        ...state.dialog,
        ...action.payload
      };
    },
    resetDialog: (state) => {
      state.dialog = initialState.dialog;
    },
    setCateory: (state, action) => {
      state.category = action.payload;
    },
    setDesignation: (state, action) => {
      state.designation = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSystemSubListV2.fulfilled, (state, action) => {
        const { subListOptions } = action.payload;

        state.subCatetory = subListOptions;
      })
      .addCase(getDisciplineListV2.fulfilled, (state, action) => {
        const { subListOptions } = action.payload;

        state.disciplineOption = subListOptions;
      })

      // === spring98 === //
      .addCase(fetchMainSystems.fulfilled, (state, action) => {
        state.mainSystems = action.payload.resultList;
      })
      .addCase(fetchSystems.fulfilled, (state, action) => {
        const systems = action.payload.resultList;

        state.systems = systems;
        state.systemOptions = systems.map((item) => ({
          label: item.cdNm,
          value: item.systemId
        }));
      })
      .addCase(getDesignations.fulfilled, (state, action) => {
        const designations = action.payload.resultList;

        state.designations = designations;
        state.designationOptions = designations.map((item) => ({
          label: item.cdNm,
          value: item.systemId
        }));
      })
      .addCase(getDisciplines.fulfilled, (state, action) => {
        const disciplines = action.payload.resultList;

        state.disciplines = disciplines;
        state.disciplineOptions = disciplines.map((item) => ({
          label: item.cdNm,
          value: item.systemId
        }));
      })
      .addCase(createSystem.fulfilled, (state, action) => {
        state.dialog.message = action.payload.message;
        state.dialog.type = IDialogType.alert;
      })
      .addCase(updateSystem.fulfilled, (state, action) => {
        state.dialog.message = action.payload.message;
        state.dialog.type = IDialogType.alert;
      })
      .addCase(deleteSystem.fulfilled, (state, action) => {
        state.dialog.message = action.payload.message;
        state.dialog.type = IDialogType.alert;
      });
  }
});

export const system = systemSlice.name;
export const systemReducer = systemSlice.reducer;
export const systemActions = systemSlice.actions;
export const {
  changeSystemDetail,
  resetSystemDetail,
  changeMainSystemDetail,
  resetDialog,
  changeDialog
} = systemSlice.actions;
export default systemSlice.reducer;
